import * as yup from 'yup';

import { REQUIRED } from '../../forms/errorsText.js';

export const validationFields = {
  createdAfter: yup.string().required(REQUIRED),
  createdBefore: yup.string().required(REQUIRED),
  byUser: yup.string(),
  byState: yup.string(),
};

export const validationSchema = yup.object().shape({ ...validationFields });

export const initialValues = (searchParams) => {
  const { q } = searchParams;

  return q;
};

export const attributesToSubmit = (values, searchParams) => {
  const attributesToSubmit = {
    ...searchParams,
    q: { ...values },
  };

  return attributesToSubmit;
};
